import { Component } from 'vue-property-decorator';
import EditorBase from '../editor/EditorBase';
import ScenePreview from '@/components/editor/ScenePreview.vue';
import { EModalName } from '@/helpers/modal';
import { ITransition } from '@/helpers/transition';

@Component({
  components: {
    ScenePreview,
  },
})
export default class SceneMixins extends EditorBase {
  shouldDisplayActivateSceneTooltip: boolean = true;

  isActiveScene(id): boolean {
    return this.selectedProjectActiveScene?.id === id;
  }

  dismissTooltip() {
    this.shouldDisplayActivateSceneTooltip = false;
  }

  get hasTransition(): boolean {
    return !!this.selectedProject?.scene_transition_id;
  }

  get sceneTransition(): ITransition {
    return this.selectedProject?.scene_transition;
  }

  openTransitionLibraryModal() {
    this.$modal.show(EModalName.transitionLibrary);
  }
}
